/**
 * Returns an action object for Redux.
 * @param {string} type - action type 
 * @param {{[string]: any} | null} meta - object containing action data.
 * @returns {{type: string, [string]: any}}
 */
export const sendAction = (type, meta = null) => (meta ? {type, ...meta} : {type});



// WEBPACK FOOTER //
// ./src/helpers/store.js